import React from "react";
import { TickerTape } from "react-tradingview-embed";

const divStyle = {
  PointerEvent: "none",
};

export default function Tickertape() {
  return (
    <div style={{ pointerEvents: "none" }}>
      <TickerTape
        widgetProps={{
          symbols: [
            {
              proName: "FX_IDC:EURUSD",
              title: "EUR/USD",
            },
            {
              proName: "BITSTAMP:BTCUSD",
              title: "BTC/USD",
            },
            {
              description: "AOA/USD",
              proName: "FX_IDC:AOAUSD",
            },
            {
              description: "AOA/BRL",
              proName: "FX_IDC:AOABRX",
            },
            {
              description: "EU/AOA",
              proName: "FX_IDC:EURAOA",
            },
            {
              description: "ZARA/AOA",
              proName: "FX_IDC:ZARAOA",
            },
            {
              description: "GBP/AOA",
              proName: "FX_IDC:GBPAOA",
            },
            {
              description: "JPY/AOA",
              proName: "FX_IDC:JPYAOA",
            },
            {
              description: "CNY/AOA",
              proName: "FX_IDC:CNYAOA",
            },
          ],
          showSymbolLogo: true,
          colorTheme: "dark",
          isTransparent: false,
          displayMode: "adaptive",
          locale: "br",
        }}
      />
    </div>
  );
}
